module.exports = __webpack_public_path__ + "img/qstudio-function.86f83caf.png";